export default "__VITE_ASSET__Ceej5l7d__"